/**
 * Handly compiled list: https://lingohub.com/developers/supported-locales/language-designators-with-regions
 * Full list: https://en.wikipedia.org/wiki/List_of_ISO_3166_country_codes
 */var IsoLanguagesRegions;
(function (IsoLanguagesRegions) {
  IsoLanguagesRegions[/** Bulgarian */"BG"] = 'bg';
  IsoLanguagesRegions[/** Czech */"CS"] = 'cs';
  IsoLanguagesRegions[/** German */"DE"] = 'de';
  IsoLanguagesRegions[/** Greek */"EL"] = 'el';
  IsoLanguagesRegions[/** English */"EN"] = 'en';
  IsoLanguagesRegions[/** English (Austrailia) */"EN_AU"] = 'en-AU';
  IsoLanguagesRegions[/** English (Canada) */"EN_CA"] = 'en-CA';
  IsoLanguagesRegions[/** English (United Kingdom) */"EN_GB"] = 'en-GB';
  IsoLanguagesRegions[/** English (India) */"EN_IN"] = 'en-IN';
  IsoLanguagesRegions[/** English (New Zealand) */"EN_NZ"] = 'en-NZ';
  IsoLanguagesRegions[/** English (United States) */"EN_US"] = 'en-US';
  IsoLanguagesRegions[/** English (South Africa) */"EN_ZA"] = 'en-ZA';
  IsoLanguagesRegions[/** Spanish */"ES"] = 'es';
  IsoLanguagesRegions[/** Finnish */"FI"] = 'fi';
  IsoLanguagesRegions[/** French */"FR"] = 'fr';
  IsoLanguagesRegions[/** French (Canada) */"FR_CA"] = 'fr-CA';
  IsoLanguagesRegions[/** French (Switzerland) */"FR_CH"] = 'fr-CH';
  IsoLanguagesRegions[/** Hungarian */"HU"] = 'hu';
  IsoLanguagesRegions[/** Italian */"IT"] = 'it';
  IsoLanguagesRegions[/** Japanese */"JA"] = 'ja';
  IsoLanguagesRegions[/** Korean */"KO"] = 'ko';
  IsoLanguagesRegions[/** Norwegian Bokmål */"NB"] = 'nb';
  IsoLanguagesRegions[/** Dutch */"NL"] = 'nl';
  IsoLanguagesRegions[/** Dutch (Belgium) */"NL_BE"] = 'nl-BE';
  IsoLanguagesRegions[/** Polish */"PL"] = 'pl';
  IsoLanguagesRegions[/** Portuguese */"PT"] = 'pt';
  IsoLanguagesRegions[/** Romanian */"RO"] = 'ro';
  IsoLanguagesRegions[/** Russian */"RU"] = 'ru';
  IsoLanguagesRegions[/** Swedish */"SV"] = 'sv';
  IsoLanguagesRegions[/** Thai */"TH"] = 'th';
  IsoLanguagesRegions[/** Turkish */"TR"] = 'tr';
  IsoLanguagesRegions[/** Vietnamese */"VI"] = 'vi';
  IsoLanguagesRegions[/** Chinese */"ZH"] = 'zh';
  IsoLanguagesRegions[/** Chinese (China) */"ZH_CN"] = 'zh-cn';
  IsoLanguagesRegions[/** Chinese (Taiwan) */"ZH_TW"] = 'zh-tw' // not currently used in BF
  ;
})(IsoLanguagesRegions || (IsoLanguagesRegions = {}));
export { IsoLanguagesRegions };